import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.SquirrelyGirl,
  voices: {
    main: {
      description:
        "bubbly young mezzo, rapid pep-squad confidence, woodland mischief, bright smiley articulation, tiny chittering excitement on laughs",
      seed: 10721,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Eat nuts and kick butts!" },
      { id: "select_2", text: "Hey there! Squirrely Girl here!" },
      {
        id: "select_3",
        text: "Hey, it's me, Squirrely Girl! In case you couldn't tell by the giant squirrel-like features.",
      },
      { id: "select_4", text: "Anybody want some nuts?" },
      {
        id: "select_5",
        text: "Oh oh! Pick me! Pick Squirrely Girl! That's me! Pick me! Pick me!",
      },
      { id: "select_6", text: "Squirrles vs. vampires? Seems fair to me!" },
    ],
    spawn: [
      { id: "spawn_1", text: "Look out world! Here comes Iron Squirrel!" },
      {
        id: "spawn_2",
        text: "Good news, Squirrel Squad! Mr. Stark brought toys for everyone!",
      },
      { id: "spawn_3", text: "Eh. Who needs spiders? I got squirrels!" },
      {
        id: "spawn_4",
        text: "Spider-Man and Squirrely Girl! Team-up of the century!",
      },
      {
        id: "spawn_5",
        text: "I beat Doctor Doom once, and I'll do it again if he gets in my face!",
      },
      {
        id: "spawn_6",
        text: "Oh, I can handle the Time Entanglement. There's been alternate versions of me forever.",
      },
      {
        id: "spawn_7",
        text: "When Doom sees me, he's gonna be shaking in his faceplate.",
      },
      {
        id: "spawn_8",
        text: "Hey, uh, quick queue… Does anybody get the feeling that Loki has bigger plans than just ruling Asgard?",
      },
      {
        id: "spawn_9",
        text: "Honestly, I'd be surprised if good ole Doomy ISN'T behind a super timey-wimey mess like this.",
      },
      {
        id: "spawn_10",
        text: "So wha-So-uh-uh-sorry-who's butt exactly are we kicking? 'Cause I got this villians trivia deck from Deadpool that I think could help.",
      },
      {
        id: "spawn_11",
        text: "Hey make fun of my tail all you want, but I've still beaten Doom, Thanos, and Galactus.",
      },
      {
        id: "spawn_12",
        text: "Hey I bet I could help with the time-fixing thingamajig. Oh-oh-Ma-Maybe I'll ask Tony next time I see him.",
      },
      {
        id: "spawn_13",
        text: "If you knew squirrels the way I know squirrels, I think you'd really like them.",
      },
      {
        id: "spawn_14",
        text: "Hey don't ever call Tippy-Toe a pet, OK? She's my best friend.",
      },
      {
        id: "spawn_15",
        text: "I think a lot of villains are just hurt and scared. It would be really nice to help them… After I ping an acorn off their foreheads.",
      },
      {
        id: "spawn_16",
        text: "Hello, my name is Doreen Green, and it makes me sad when people don't listen to animals.",
      },
      {
        id: "spawn_17",
        text: "Being a super hero is a piece of cake compared to being Luke Cage's nanny. Now that was stressful!",
      },
      {
        id: "spawn_18",
        text: "Oh-Ah, my tail? Yeah, it's super warm, and it's very handy in combat.",
      },
      {
        id: "spawn_19",
        text: "Ah, this is Tippy Toe, and she has the powers… of, umm… Just a-a regular squirrel.",
      },
      {
        id: "spawn_20",
        text: "I-I-I do still kind of have a crush on Wolverine. Heh…",
      },
      {
        id: "spawn_21",
        text: 'When other people first saw my powers they we\'re like: "Wait. A squirrel…?" And now they\'re like: "Oh! A SQUIRREL!" He-he!',
      },
      {
        id: "spawn_22",
        text: "Well I-I, so… I have a genetic anomaly but I'm not a mutant. And-and please don't ask me what the difference is cause I don't know.",
      },
      {
        id: "spawn_23",
        text: "We're about to find out whose got sharper teeth: us or them.",
      },
      {
        id: "spawn_24",
        text: "Try not to fall under Dracula's control this time, okay, gang?",
      },
      { id: "spawn_25", text: "More vampires? Here we go again, Tippy…" },
      { id: "spawn_26", text: "One vampire boss fight, coming right up!" },
      {
        id: "spawn_27",
        text: "Oh, geez! Dracula?! I hope I brought enough acorns…",
      },
      {
        id: "spawn_28",
        text: "Fight the power! And by power, I mean Mayor Fisk.",
      },
      {
        id: "spawn_29",
        text: "Get ready, pals. There's plenty of Fisk to sink your tiny teeth into!",
      },
      {
        id: "spawn_30",
        text: "Ratatoskr? What did Dracula do to you? You've gotta fight it, girl!",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I'm not done with this fight yet!" },
      { id: "respawn_2", text: "Boun'in back into action!" },
      { id: "respawn_3", text: "Here I come again!" },
      { id: "respawn_4", text: "We're back, right, Tippy-Toe?" },
    ],
    ult_ally: [{ id: "ult_ally", text: "My friends are here!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Squirrel stampede!" }],
    secondary: [
      { id: "secondary_1", text: "Hooah! Get 'em, squirrels!" },
      { id: "secondary_2", text: "Hah! Where do you think you're going?" },
      { id: "secondary_3", text: "Hey, check out this big acorn! Pew!" },
    ],
    ability2: [
      { id: "ability2_1", text: "Hmm, time to go nuts!" },
      { id: "ability2_2", text: "Woo! I'm energized!" },
      { id: "ability2_3", text: "Woo! Now that's a snack!" },
    ],
    kill: [
      { id: "kill_1", text: "Score one for the squirrels!" },
      { id: "kill_2", text: "That's squirrel power!" },
      { id: "kill_3", text: "That last acorn's a doozy!" },
      { id: "kill_4", text: "Take that, ya villain!" },
      { id: "kill_5", text: "Got 'em, Tippy!" },
    ],
    multikill: [
      { id: "multikill_1", text: "Easy as one two three!" },
      { id: "multikill_2", text: "Let's make it four!" },
      { id: "multikill_3", text: "Three-for-three!" },
      { id: "multikill_4", text: "Yay! Gimme five, Tippy-Toe!" },
      { id: "multikill_5", text: "Five? Already? Awesome!" },
      { id: "multikill_6", text: "Couldn't do it alone!" },
      { id: "multikill_7", text: "And you folks can get some next time!" },
      { id: "multikill_8", text: "We ran out of bad guys!" },
      { id: "multikill_9", text: "Cool!" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Ah, you're a life-saver!" },
      { id: "low_hp_2", text: "Whew, I was hurting for a certain." },
    ],
    healed: [
      { id: "healed_1", text: "Oh, a touch of healing!" },
      { id: "healed_2", text: "I appreciate you!" },
      { id: "healed_3", text: "Woo, I'm feeling good!" },
      { id: "healed_4", text: "Ah, Zing!" },
    ],
  },
} satisfies VoiceScript;

export default script;
